import React from "react";
import Icon, { type IconProps } from "./Icon";
/** ArrowDown — Lucide. https://lucide.dev/icons/arrow-down (MIT). Copied 2026-05-16.
 *  Phase 3d: directional pairing with status colors (vs Target behind, KPI
 *  delta negative). */
export default function ArrowDown(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M12 5v14" />
      <path d="m19 12-7 7-7-7" />
    </Icon>
  );
}
